module.exports = __webpack_public_path__ + "static/media/landing_slider_image_3.ac1f997b.jpg";